export const nl = {
    // Italiaanse vertalingen:
    required: '* Verplicht veld',
    validation: {
        required: controlName => `Gelieve ${controlName === null || controlName === void 0 ? void 0 : controlName.toLowerCase()} in te vullen`,
        minmaxNotLessThen: (controlName, min) => `${controlName === null || controlName === void 0 ? void 0 : controlName.toLowerCase()} mag niet minder zijn dan ${min}`,
        minmaxNotGreaterThen: (controlName, max) => `${controlName === null || controlName === void 0 ? void 0 : controlName.toLowerCase()} mag niet meer zijn dan ${max}`,
    },
    switch: {
        yes: 'Ja',
        no: 'Nee',
    },
    dateRange: {
        arrival: 'Aankomst',
        departure: 'Vertrek',
    },
    travelData: {
        title: 'Voer uw vakantiegegevens in en ontvang gepersonaliseerde aanbiedingen per e-mail, rechtstreeks van de accommodaties.',
        range: 'aankomst- en vertrekdatum',
        hasPets: 'Huisdieren',
        petsMessage: 'beschrijving huisdieren',
        petsMessagePlaceholder: "bijv. 1 grote hond (ongeveer 10 kg), 2 katten...",
        boards: 'Verzorging',
        rooms: {
            validation: {
                roomsMissing: 'Voer minimaal 1 kamer in',
                adultsMissing: 'Voer het aantal volwassenen in',
                roomsWithoutAdults: 'Voer minimaal 1 volwassene per kamer in',
                childAgeMissing: 'Voer de leeftijd van de kinderen in',
            },
            adults: 'Volwassenen',
            children: 'Kinderen',
            rooms: 'Kamers',
            age: 'Leeftijd',
            room: 'Kamer/appartement',
            roomInfo: 'Informatie met betrekking tot een kamer, appartement, staanplaats, enz.',
            removeRoom: 'Kamer/appartement verwijderen',
            addRoom: 'Kamer/appartement toevoegen',
            childrenAges: 'Leeftijden van kinderen',
            years: age => `${age} ${age == 1 ? 'jaar' : 'jaar'}`,
            done: 'Gereed',
        },
        submit: 'Doorgaan',
    },
    filter: {
        title: 'Kies het type accommodatie en de gewenste regio en ontdek welke accommodaties aan uw wensen voldoen!',
        accotypesValidatorText: controlName => `Kies ${controlName === null || controlName === void 0 ? void 0 : controlName.toLowerCase()}`,
        areaValidatorText: controlName => `Kies ${controlName === null || controlName === void 0 ? void 0 : controlName.toLowerCase()}`,
        maxCountValidatorText: (controlName, max) => `U kunt maximaal ${max} accommodaties selecteren.\nGebruik andere filters.`,
        accotypesAndBoards: 'Type accommodatie & verzorging',
        boards: 'Verzorging',
        accotypes: 'Type accommodatie',
        areas: 'Regio\'s & locaties',
        resorts: 'Locaties',
        regions: 'Regio\'s',
        selectAllRegions: 'Selecteer alle regio\'s in Zuid-Tirol',
        searchAreas: 'Zoek regio\'s en locaties...',
        themesAmeneties: 'Voorzieningen / Soort vakantie',
        ameneties: 'Voorzieningen',
        themes: 'Soort vakantie',
        overlay: {
            accosText: count => `<b>${count}</b> ${count == 1 ? "accommodatie" : "accommodaties"} geselecteerd`,
            done: 'Gereed',
        },
        back: 'Terug',
        submitContinueWith: 'Doorgaan met',
        submitAccosText: count => `${count} ${count == 1 ? "accommodatie" : "accommodaties"}`,
    },
    accos: {
        title: 'Overzicht van accommodaties',
        subtitle: (selected, count) => `Stuur een aanvraag naar ${selected} ${selected == 1 ? "accommodatie" : "accommodaties"} of kies een specifieke accommodatie`,
        back: 'Terug',
        submitContinueWith: 'Doorgaan met',
        submitAccosText: count => `${count} ${count == 1 ? "accommodatie" : "accommodaties"}`,
    },
    personalData: {
        accosCount: count => `<b>${count}</b> ${count == 1 ? "accommodatie" : "accommodaties"}`,
        adults: count => `<b>${count}</b> ${count == 1 ? 'Volwassen' : 'Volwassenen'}`,
        children: count => `<b>${count}</b> ${count == 1 ? 'Kind' : 'Kinderen'}`,
        rooms: count => `<b>${count}</b> ${count == 1 ? 'Kamer' : 'Kamer'}`,
        pets: 'Huisdier/en',
        accotypes: count => `${count == 1 ? 'Type accommodatie:' : 'Typen accommodatie:'}`,
        areas: count => `${count == 1 ? `Regio/locatie:` : `Regio's/locaties:`}`,

        title: 'Voer uw gegevens in om gepersonaliseerde aanbiedingen rechtstreeks van de accommodaties te ontvangen!',
        email: 'E-mail',
        salutation: 'Aanhef',
        salutationOptions: {
            herr: 'De heer',
            frau: 'Mevrouw',
            familie: 'Familie',
            firma: 'Bedrijf',
        },
        firstname: 'Voornaam',
        lastname: 'Achternaam',
        phone: 'Telefoon',
        message: 'Opmerkingen & vragen',
        privacy: privacyUrl => `Ja, ik geef toestemming voor de <a href="${privacyUrl}" target="_blank">verwerking van mijn persoonlijke gegevens</a>.`,
        privacyRequired: 'Toestemming voor gegevensverwerking vereist',
        newsletter: 'Ja, ik wil de nieuwsbrief van alto-adige.com ontvangen',
        newsletterNote: 'Onze gratis nieuwsbrief wordt regelmatig eens per maand verzonden, met de beste aanbiedingen voor vakanties in Zuid-Tirol en handige tips van de redactie. U kunt zich op elk moment afmelden.',
        generalError: 'Er is een probleem opgetreden. Probeer het later opnieuw.',
        back: 'Terug',
        submit: count => `Aanvraag verzenden`,
    },
    thankyou: {
        title: 'Aanvraag succesvol verzonden',
        successText: 'De aanvraag is succesvol verzonden',
    },
};
//# sourceMappingURL=Enquiry.i18n.nl.js.map